import { render, staticRenderFns } from "./EventHistoryComments.vue?vue&type=template&id=114e90dc&scoped=true&"
import script from "./EventHistoryComments.vue?vue&type=script&lang=js&"
export * from "./EventHistoryComments.vue?vue&type=script&lang=js&"
import style0 from "./EventHistoryComments.vue?vue&type=style&index=0&id=114e90dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114e90dc",
  null
  
)

export default component.exports